export enum DebugScreen {
  BookkeepingCategories = 'bookkeepingCategories',
  AccountingConfiguration = 'accountingConfiguration',
  Scopes = 'scopes',
  RemoteFeatureFlags = 'remoteFeatureFlags',
  OrganizationInfo = 'organizationInfo',
}
